import { render, staticRenderFns } from "./Accountmanagement.vue?vue&type=template&id=1c324c2a&scoped=true"
import script from "./Accountmanagement.vue?vue&type=script&lang=js"
export * from "./Accountmanagement.vue?vue&type=script&lang=js"
import style0 from "./Accountmanagement.vue?vue&type=style&index=0&id=1c324c2a&prod&scoped=true&lang=scss"
import style1 from "./Accountmanagement.vue?vue&type=style&index=1&id=1c324c2a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c324c2a",
  null
  
)

export default component.exports